import PUBLIC_PAGE_STATUS from 'constants/publicPage';
import { IPublicPageDocumentStructure, IPublicPageGeneralStructure } from 'types/PublicPage';

const getIsTheLastDocumentAndAllOthersDone = ({ documents }: IPublicPageGeneralStructure): boolean => documents.filter(
  ({ status }: IPublicPageDocumentStructure) => (
    status !== PUBLIC_PAGE_STATUS.DONE
  ),
).length <= 1;

export default getIsTheLastDocumentAndAllOthersDone;